import React from 'react'
import Busi from "./Busi"
import Fast from './Fast'
import IconSlide from "./IconSlide"
import Lead from './Lead'
import Looking from './Looking'
import Offer from './Offer'
import Remote from './Remote'
import Tech from './Tech'
import Hold from "./Hold"
import Welcome from './Welcome'
import Elevate from './Elevate'
import Grow from "./Grow"
import Footer from './Footer'

const Business = () => {
  return (
    <div>
        <Busi />
        <IconSlide />
        <Looking />
        <Lead />
        <Fast />
        <Tech />
        <Offer />
        <Remote />
        <Hold />
        <Welcome />
        <br />
        <br />
        <br />
        <br />
        <Elevate />
        <Grow />
        <Footer />
    </div>
  )
}

export default Business